import { ISendActionGet } from '@EcamModel/controllers/IPTZCamConfigureRequestHttpController';
import { useState } from 'react';

export enum SectionsCollapsePMC8266 {
    ParkingManagement = 'parking_management',
    DetectionSettings = 'detection_settings',
    ReportSettings = 'report_settings',
    AlarmSettings = 'alarm_settings',
    StorageManagement = 'storage_management',
    RecordSettings = 'record_settings',
    SnapshotSettings = 'snapshot_settings',
    MotionDetectionBasicSettings = 'motionDetection_basicSettings',
    MotionDetectionScheduleSettings = 'motionDetection_scheduleSettings',
    SetTheSystemTime = 'set_the_systemTime',
    CurrentSystemTime = 'current_systemTime',
}

export interface LoadingState {
    PMC8266Settings: boolean;
}

type Props = {
    filteredCamera: ISendActionGet;
    cameraPMC8266: number;
};

export default function useMileSightPMC8266(props: Props) {
    const [isOpenCollapse, setIsOpenCollapse] = useState<{ [key in SectionsCollapsePMC8266]: boolean }>({
        parking_management: true,
        detection_settings: false,
        report_settings: false,
        alarm_settings: false,
        storage_management: false,
        record_settings: false,
        snapshot_settings: false,
        motionDetection_basicSettings: false,
        motionDetection_scheduleSettings: false,
        set_the_systemTime: false,
        current_systemTime: false,
    });

    return {
        isOpenCollapse,
        setIsOpenCollapse,
    };
}
